module.exports = "<div class=\"ui-g-12 ui-md-2\">\r\n  <label>Geographical Region:</label>\r\n</div>\r\n<!-- Using ngIf due to issue https://github.com/primefaces/primeng/issues/6766 -->\r\n<div class=\"ui-g-12 ui-md-6\" *ngIf=\"azureRegions\">\r\n  <p-dropdown [(ngModel)]=\"selectedRegion\" [options]=\"azureRegions\" [disabled]=\"isDisabled\"></p-dropdown>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/region-selection/region-selection.component.html
// module id = ./src/app/components/region-selection/region-selection.component.html
// module chunks = main